import { Box } from '@mui/material';
import { useEffect, useState } from 'react';

interface RemoteImageIconProps {
  imageUrl: string;
  fallbackIcon: React.ReactNode;
}

export default function RemoteImageIcon({ imageUrl, fallbackIcon }: RemoteImageIconProps) {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [errorLoading, setErrorLoading] = useState(false);

  useEffect(() => {
    // Resetar estado quando a URL muda
    setImageLoaded(false);
    setErrorLoading(false);
  }, [imageUrl]);

  // Se não temos URL ou ocorreu erro, mostrar ícone padrão
  if (!imageUrl || errorLoading) {
    return <>{fallbackIcon}</>;
  }

  return (
    <Box sx={{ position: 'relative', width: '100%', height: '100%' }}>
      {!imageLoaded && (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
          {fallbackIcon}
        </Box>
      )}
      <img
        src={imageUrl}
        alt="Documento"
        onLoad={() => setImageLoaded(true)}
        onError={() => setErrorLoading(true)}
        style={{
          width: '100%',
          height: '100%',
          maxHeight: '60px',
          objectFit: 'contain',
          display: imageLoaded ? 'block' : 'none'
        }}
      />
    </Box>
  );
}
